import { render, staticRenderFns } from "./carsrequest.vue?vue&type=template&id=35a7d5ba"
import script from "./carsrequest.vue?vue&type=script&lang=js"
export * from "./carsrequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports